import { Box, Divider, Grid, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DetailCard from "../../../../components/display/DetailCard";
import TextEditorViewer from "../../../../components/display/TextEditorViewer";
import VaccinationTable from "../../singleView/components/VaccinationTable";
import { VaccinesOutlined } from "@mui/icons-material";

export default function AppointmentSingleRevisionStatic({ data, otherData }) {
  const { t } = useTranslation();
  if (data == null) {
    return t("NoInfo");
  }
  const pet = data?.pet;
  const biometrics = data?.biometrics;
  const vaccines = data?.vaccinations;

  const detailsArray = [
    { title: "ID", value: data?.appointmentId },
    { title: "StartDate", value: data?.startDate },
    { title: "EndDate", value: data?.endDate },
    { title: "Status", value: t(data?.status) },
    { title: "StatusMessage", value: data?.statusMessage ?? null },
    { title: "Service", value: data?.priceList?.title ?? null },
    { title: "Description", value: data?.description ?? null },
  ].filter((item) => item.value);

  const petArray = [
    { title: "ID", value: pet?.id },
    { title: "Name", value: pet?.name },
    { title: "Type", value: pet?.species },
    { title: "Birthdate", value: pet?.birthdate },
    { title: "Description", value: pet?.description },
  ].filter((item) => item.value);

  const biometricsArray = [
    { title: "CreatedBy", value: biometrics?.createdBy },
    { title: "CreatedAt", value: biometrics?.createdAt },
    { title: "FrequencyOfBreathing", value: biometrics?.breathingFrequency },
    { title: "Puls/Min", value: biometrics?.heartRate },
    { title: "Height", value: biometrics?.height },
    { title: "Length", value: biometrics?.length },
    { title: "BodyTemperature", value: biometrics?.temperature },
    { title: "Mass", value: biometrics?.weight },
  ].filter((item) => item.value);

  const author = getAuthorVal(otherData);

  return (
    <Stack spacing={2}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h5" textAlign={"center"}>
          {t("RevisionInformation")}
        </Typography>
        <Divider sx={{ m: 1 }} />
        <DetailCard paper={false} value={author} title={"Author"} />
        <Grid container>
          <Grid item xs={6}>
            <DetailCard
              paper={false}
              value={t(otherData?.action)}
              title={"Action"}
            />
          </Grid>
          <Grid item xs={6}>
            <DetailCard paper={false} value={otherData?.date} title={"Date"} />
          </Grid>
        </Grid>
      </Paper>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h5" textAlign={"center"}>
          {t("AppointmentInformation")}
        </Typography>
        <Divider sx={{ m: 1 }} />
        <DetailCard
          paper={false}
          valueArray={detailsArray}
          grid
          gridCount={2}
        />
      </Paper>
      {pet != null ? (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h5" textAlign={"center"}>
            {t("PetInformation")}
          </Typography>
          <Divider sx={{ m: 1 }} />

          <DetailCard paper={false} valueArray={petArray} grid gridCount={2} />
        </Paper>
      ) : null}

      {biometrics != null ? (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h5" textAlign={"center"}>
            {t("BiometricsInformation")}
          </Typography>
          <Divider sx={{ m: 1 }} />

          <DetailCard
            paper={false}
            valueArray={biometricsArray}
            grid
            gridCount={2}
          />
        </Paper>
      ) : null}
      {vaccines && vaccines.length > 0 ? (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h5" textAlign={"center"}>
            {t("VaccinationInformation")}
          </Typography>
          <Divider sx={{ m: 1 }} />
          <VaccinationTable vaccinations={vaccines} />
        </Paper>
      ) : null}
      
      {data?.treatment?.description ? (
        <Paper sx={{ p: 2 }}>
          <Typography variant="h5" textAlign={"center"}>
            {t("Treatment")}
          </Typography>
          <Divider sx={{ m: 1 }} />
          <TextEditorViewer value={data?.treatment?.description} />
        </Paper>
      ) : null}
    </Stack>
  );
}

function getAuthorVal(otherData) {
  var author = null;
  author =
    String(otherData?.action) === "Created"
      ? `${otherData?.creator}`
      : `${otherData?.modificator}`;

  if (author != null) {
    return author;
  }
  return "NoInfo";
}
